const SubAbasDominios = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/adm/dominios/dominio/${id}/dadosgerais`,
  },
];

export default SubAbasDominios;
